import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { MessageSquare, LogOut, BarChart2, Reply, Home as HomeIcon, ClipboardList } from 'lucide-react';
import logo from '../../assets/images/pulso-logo.png';
import '../../styles/pulso.css';

export function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/messages', label: 'Messages', icon: MessageSquare },
    { path: '/respond', label: 'Respond', icon: Reply },
    { path: '/meeting-notes', label: 'Meeting Notes', icon: ClipboardList },
    { path: '/overview', label: 'Overview', icon: BarChart2 },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 border-b border-border bg-card">
        <div className="flex h-16 items-center justify-between px-6">
          <div className="flex items-center gap-8">

            {/* Logo — uses shared .nav-logo classes from pulso.css */}
            <button onClick={() => navigate('/')} className="nav-logo" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
              <img src={logo} alt="Pulso" className="nav-logo-img" style={{ width: 60 }} />
              <div className="nav-logo-text-wrap">
                <span className="nav-logo-name">PULSO</span>
                <span className="nav-logo-by">by Imaginarium</span>
              </div>
            </button>

            {/* Nav links */}
            <nav className="hidden md:flex items-center gap-1">
              {navItems.map((item) => {
                const Icon = item.icon;
                const active = isActive(item.path);
                return (
                  <button
                    key={item.path}
                    onClick={() => navigate(item.path)}
                    className={`flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors ${active
                        ? 'bg-accent text-accent-foreground'
                        : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                      }`}
                  >
                    <Icon className="h-4 w-4" />
                    {item.label}
                  </button>
                );
              })}
            </nav>
          </div>

          {/* User menu */}
          <div className="flex items-center gap-4">
            <div className="hidden md:block text-sm text-muted-foreground">
              {user?.name}
            </div>
            <button
              onClick={handleLogout}
              className="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2 gap-2 transition-colors"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Logout</span>
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-6 py-8">
        {children}
      </main>
    </div>
  );
}